<template>
  <div>
    <top v-if="!noHeadAndFoot" />
    <!--#routerEle优化footer在页面未加载完成时出现在页面顶部，配合/src/permission.js里的方法-->
    <!-- <div id="routerEle" style="min-height:100vh"><router-view /></div> -->
    <!-- <div id="routerEle" style="min-height: 100vh"> -->
       <div id="routerEle" style="min-height: 100px">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive">
          <!-- 这里是会被缓存的视图组件-->
        </router-view>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- 这里是不被缓存的视图组件 -->
    </div>

    <foot v-if="!noHeadAndFoot"></foot>
  </div>
</template>

<script>
import top from "./components/header/head";
import foot from "./components/foot/foot";
export default {
  name: "default",
  components: {
    top,
    foot,
  },
  computed: {
    noHeadAndFoot() {
      return this.$route.meta.noHeadAndFoot;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

.content {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/default.vue